import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { SetCtaValueAction, adapter, setCtaValue } from './slice';
import { RootState } from '@/redux/store';
import { dumpState } from '@/lib/utils/local-state';

export const localStorage = createListenerMiddleware();

localStorage.startListening({
  matcher: isAnyOf(setCtaValue),

  effect: (action: SetCtaValueAction, listenerApi) => {
    const { ctaSlice } = listenerApi.getState() as RootState;
    // Update the entire slice in localStorage
    dumpState(adapter, ctaSlice);
  },
});
